module.exports = __webpack_public_path__ + "static/assets/a283a61feaf40df801323476898dee6b.svg";